const getLocks = (state) => {
  return state.locks;
};

const getLockById = (state) => (id) => {
  return state.locks[id] || null;
};

const isLockedByAnother = (state) => (id, currentUserId) => {
  const lock = state.locks[id];

  if (!lock) {
    return false;
  }

  return String(lock.userId) !== String(currentUserId);
};

export default {
  getLocks,
  getLockById,
  isLockedByAnother
};
